<template>
  <div>
    <el-form :model="form" ref="ruleForm" class="feedback-form">
      <div class="form-title">面試意見回饋表</div>

      <div class="text-center">
        <el-button
          class="mb-2"
          type="primary"
          :disabled="writing"
          v-if="!writing"
          @click="writing = true"
          >開始填寫</el-button
        >
      </div>

      <table class="feedback-table">
        <tr>
          <th scope="row" rowspan="3" class="text-center">基本資料</th>
          <th scope="row">姓名</th>
          <td>
            <el-form-item
              prop="Name"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-input v-model="form.Name" :disabled="!writing"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">Email</th>
          <td>
            <el-form-item
              prop="Email"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-input v-model="form.Email" :disabled="!writing"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">手機號碼</th>
          <td>
            <el-form-item
              prop="Phone"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-input v-model="form.Phone" :disabled="!writing"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row" rowspan="5" class="text-center">邀約</th>
          <th scope="row">1.是否為日月光主動邀約面談？(填否請跳至第6題)</th>
          <td>
            <el-form-item
              prop="radio1"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group
                v-model="form.radio1"
                :disabled="!writing"
                @change="questionOneChange"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">2.邀約面試人員是否明確介紹公司及職務內容？</th>
          <td>
            <el-form-item
              prop="radio2"
              :rules="[{ required: lock ? false : true, message: '必填' }]"
            >
              <el-radio-group
                v-model="form.radio2"
                :disabled="!writing || lock"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">3.邀約面試人員是否積極主動、態度親切？</th>
          <td>
            <el-form-item
              prop="radio3"
              :rules="[{ required: lock ? false : true, message: '必填' }]"
            >
              <el-radio-group
                v-model="form.radio3"
                :disabled="!writing || lock"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">4.邀約人員是否清楚說明面試時間、攜帶物品與聯絡方式？</th>
          <td>
            <el-form-item
              prop="radio4"
              :rules="[{ required: lock ? false : true, message: '必填' }]"
            >
              <el-radio-group
                v-model="form.radio4"
                :disabled="!writing || lock"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">5.是否確實收到邀約面試通知？(例如：簡訊、信件、電話…等)</th>
          <td>
            <el-form-item
              prop="radio5"
              :rules="[{ required: lock ? false : true, message: '必填' }]"
            >
              <el-radio-group
                v-model="form.radio5"
                :disabled="!writing || lock"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row" rowspan="3" class="text-center">接待</th>
          <th scope="row">6.換證流程是否流暢？</th>
          <td>
            <el-form-item
              prop="radio6"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio6" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">7.指示牌是否清楚或指引人員是否積極主動、態度親切？</th>
          <td>
            <el-form-item
              prop="radio7"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio7" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">8.面試環境是否滿意？</th>
          <td>
            <el-form-item
              prop="radio8"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio8" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row" rowspan="3" class="text-center">流程</th>
          <th scope="row">
            9.招募人員是否清楚介紹工作相關訊息？(例如：公司職務內容、薪資福利…等)
          </th>
          <td>
            <el-form-item
              prop="radio9"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio9" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">10.是否清楚今日面試流程階段？</th>
          <td>
            <el-form-item
              prop="radio10"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio10" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">11.各流程等待時間是否合理？</th>
          <td>
            <el-form-item
              prop="radio11"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio11" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row" rowspan="4" class="text-center">面談</th>
          <th scope="row">12.招募人員詢問的問題是否恰當？</th>
          <td>
            <el-form-item
              prop="radio12"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio12" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">13.面試官詢問的問題是否恰當？</th>
          <td>
            <el-form-item
              prop="radio13"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio13" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row">14.招募人員是否態度親切且專業?</th>
          <td>
            <el-form-item
              prop="radio14"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio14" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row">15.面試官是否態度親切且專業?</th>
          <td>
            <el-form-item
              prop="radio15"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio15" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row" class="text-center">通知</th>
          <th scope="row">16.招募人員是否清楚說明面談後的等候通知時間及後續通知流程？</th>
          <td>
            <el-form-item
              prop="radio16"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio16" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th scope="row" class="text-center">總結</th>
          <th scope="row">17.針對今日整體面談過程是否滿意</th>
          <td>
            <el-form-item
              prop="radio17"
              :rules="[{ required: true, message: '必填' }]"
            >
              <el-radio-group v-model="form.radio17" :disabled="!writing">
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <th scope="row" colspan="3" class="text-center">
            今日面試過程中，若有任何問題、改善或建議，請給予我們最直接的回饋，謝謝！
          </th>
        </tr>
        <tr>
          <td colspan="3">
            <el-form-item>
              <el-input
                :disabled="!writing"
                style="width: 100%"
                type="textarea"
                :rows="2"
                placeholder="請輸入內容"
                v-model="form.textarea"
              >
              </el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
      <div class="text-center">
        <el-button
          type="primary"
          round
          style="margin-top: 10px"
          v-if="writing"
          @click="submitForm('ruleForm')"
          >送出</el-button
        >
      </div>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>確實填寫完成?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >確 認</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      dialogVisible: false,
      writing: false,
      lock: false,
      form: {
        radio1: null,
        radio2: null,
        radio3: null,
        radio4: null,
        radio5: null,
      },
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    questionOneChange(val) {
      if (val === "否") {
        this.lock = true;
        this.form.radio2 = null;
        this.form.radio3 = null;
        this.form.radio4 = null;
        this.form.radio5 = null;

        this.$refs["ruleForm"].clearValidate([
          "radio2",
          "radio3",
          "radio4",
          "radio5",
        ]);
      } else {
        this.lock = false;
      }
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.feedback-form {
  max-width: 960px;
  margin: 20px auto;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  table {
    width: 100%;
  }
  .form-title {
    text-align: center;
    font-weight: bold;
    margin: 10px 0;
  }
  th {
    background-color: #f5f5f5;
    font-weight: normal;
    white-space: nowrap;
  }
  td,
  th {
    border: 1px solid #ccc;
    padding: 5px;
    font-size: 0.9em;
  }
  .el-select {
    width: 100%;
  }
  .el-checkbox {
    transform: scale(1.5);
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .el-form-item__error {
    background-color: #f56c6c;
    color: #fff;
    padding: 3px 10px;
    border-radius: 25px;
    float: right;
  }
}
</style>
